<script lang="ts">
	import { switchToOptimism } from '$lib/wallet/wallet';
</script>

<div
	class="flex justify-center items-center gap-3 text-fx-grey-900 font-semibold text-center rounded-xl squircle-xl bg-fx-gradient-9 py-3 sm:py-4 cursor-pointer text-xs sm:text-sm w-full"
	on:click={switchToOptimism}
	on:keydown={switchToOptimism}
	role="presentation"
>
	Switch to Optimism
</div>
